import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Teams() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://bot-battle-server.vercel.app/users')
      .then(response => response.json())
      .then(data => setUsers(data))
      .catch(error => console.error('Error fetching users:', error));
  }, []);

  const handleCreateTeamClick = () => {
    navigate('/myteam');
  };

  const handleRowClick = (userId) => {
    navigate(`/user/${userId}`);
  };

  const handleDeleteClick = (userId) => {
    fetch(`https://bot-battle-server.vercel.app/users/${userId}`, {
      method: 'DELETE',
    })
      .then(response => {
        if (response.ok) {
          setUsers(users.filter(user => user.id !== userId));
        } else {
          console.error('Error deleting user');
        }
      })
      .catch(error => console.error('Error deleting user:', error));
  };

  return (
    <div className="flex justify-center flex-col mt-44 text-black">
      <div className='flex justify-end mr-20'>
        <button
          onClick={handleCreateTeamClick}
          className="mb-6 p-2 bg-purple-500 text-white rounded-lg"
        >
          Bots Collection
        </button>
      </div>
      <div>
        <h2 className="text-2xl mb-2 text-white text-center font-extrabold">List of Users</h2>
        <table className="min-w-full bg-slate-200 border border-slate-500 rounded-lg">
          <thead className='bg-slate-700 text-white'>
            <tr>
              <th className="border-b border-slate-500 p-2 text-left">Name</th>
              <th className="border-b border-slate-500 p-2 text-left">Email</th>
              <th className="border-b border-slate-500 p-2 text-left">Username</th>
              <th className="border-b border-slate-500 p-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr
                key={user.id}
                className="cursor-pointer hover:bg-slate-300"
              >
                <td className="border-b border-slate-500 p-2" onClick={() => handleRowClick(user.id)}>{user.name}</td>
                <td className="border-b border-slate-500 p-2" onClick={() => handleRowClick(user.id)}>{user.email}</td>
                <td className="border-b border-slate-500 p-2" onClick={() => handleRowClick(user.id)}>{user.username}</td>
                <td className="border-b border-slate-500 p-2">
                  <button
                    onClick={() => handleDeleteClick(user.id)}
                    className="p-2 bg-red-500 text-white rounded-lg"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Teams;
